import { render, staticRenderFns } from "./ClientRiskDropdown.vue?vue&type=template&id=de02cace&scoped=true&"
import script from "./ClientRiskDropdown.vue?vue&type=script&lang=js&"
export * from "./ClientRiskDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de02cace",
  null
  
)

export default component.exports